import { render } from "./tree-item.vue?vue&type=template&id=1052723c&scoped=true"
import script from "./tree-item.vue?vue&type=script&lang=js"
export * from "./tree-item.vue?vue&type=script&lang=js"

import "./tree-item.vue?vue&type=style&index=0&id=1052723c&scoped=true&lang=scss"

import exportComponent from "/Users/simon/www/earth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1052723c"]])

export default __exports__